import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { TipoBeneficio } from './../../_models/Enums/tipoExperiencia';

@Component({
  selector: 'app-lovers-pela-causa',
  templateUrl: './lovers-pela-causa.component.html',
  styleUrls: ['./lovers-pela-causa.component.scss'],
})
export class LoversPelaCausaComponent implements OnInit {
  private readonly MIN_VALUE_CACAUS: number = 0;
  private readonly MAX_VALUE_CACAUS: number = 150;
  private readonly TIPOS_EXPERIENCIA: any = `[${TipoBeneficio.Promocao},${TipoBeneficio.Experiencia},${TipoBeneficio.ComResgateDeProdutos}]`;

  public minValue: number = this.MIN_VALUE_CACAUS;
  public maxValue: number = this.MAX_VALUE_CACAUS;

  public experiencias: any[] = [];
  public experiencia: any;
  public quantidadeCards: number = 0;

  public urlAtual: string = window.location.href;
  public paginaPelaCausa: boolean = false;

  public carregandoCards: boolean = false;

  membro: any = undefined;

  constructor(
    private FidelidadeService: FidelidadeService,
    private authService: AuthService,
    private el: ElementRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.carregarMomentosLoversPelaCausa();

    if (this.authService.LocalStorage.obterToken() != '') {
      this.obterMembro();
    }
    this.paginaPelaCausa = this.urlAtual.includes('/pela-causa');
  }

  private obterMembro() {
    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any) {
    this.membro = res;
    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
  }

  public carregarMomentosLoversPelaCausa() {
    this.carregandoCards = true;
    this.experiencias = [];
    var filtroExperiencia: any = {
      tipos: this.TIPOS_EXPERIENCIA,
      niveis: this.obterFiltroNiveis(),
      estados: this.obterFiltroEstados(),
      categorias: this.obterFiltroCategorias(),
      campanhas: this.obterFiltroCampanhas(),
      ordem: this.obterFiltroOrdem(),
      descricao: '',
      rangeCacaus: null,
      somenteAtivos: false,
      ehTelaMomentoEspecial: false,
    };

    this.FidelidadeService.searchExperiencias(filtroExperiencia).subscribe({
      next: (res: any) => {
        this.experiencias = res.resultado;
        this.carregandoCards = false;
        this.quantidadeCards = res.resultado.length;
      },
      error: (err: any) => {
        this.carregandoCards = false;
        console.log(err);
      },
    });
  }

  public irParaMomentosEspeciais() {
    if (this.paginaPelaCausa) {
      const link = '/momentos-especiais?categoria=social';
      this.router.navigate(['/home'], {
        queryParams: {
          redirectLink: btoa(link),
          login: btoa('1'),
        },
      });
    } else {
      this.router.navigate(['/momentos-especiais'], {
        queryParams: { categoria: 'social' },
      });
    }
  }

  private obterFiltroNiveis(): string {
    var result = '';
    return result;
  }

  private obterFiltroEstados(): string {
    var result = '';
    return result;
  }

  private obterFiltroCategorias(): string {
    return '[8]';
  }

  private obterFiltroCampanhas(): string {
    return '';
  }

  private obterFiltroOrdem(): string {
    return '';
  }

  private obterFiltroRange(): string {
    const list = [this.minValue, this.maxValue];

    return this.obterString(list);
  }

  private obterString(lista: any): string {
    return '[' + lista.join(',') + ']';
  }
}
